export default "__VITE_ASSET__kQ7$bM_t__"